import { render } from "./ProductStarterset.vue?vue&type=template&id=318f8bdf"
import script from "./ProductStarterset.vue?vue&type=script&lang=js"
export * from "./ProductStarterset.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__